import React from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import { useHistory } from "react-router-dom";
import FeelingProud from "./FeelingProud";

export default function Greeting(props) {
  const theme = props.theme;
  const history = useHistory();

  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text">
                {greeting.title}
                <br />
                <span style={{ fontSize: "0.7em" }}>{greeting.title2}</span>
              </h1>
              <p
                className="greeting-text-p"
                style={{ color: theme.secondaryText }}
              >
                <span>I'm </span>
                <span className="gradient-text" style={{ fontWeight: "bold" }}>
                  {greeting.full_name}
                </span>
                <br />
                {greeting.subTitle}
              </p>
              <SocialMedia />
              <div className="portfolio-repo-btn-div">
                <button
                  className="button"
                  onClick={() => {
                    history.push("/contact");
                  }}
                >
                  Contact Me
                </button>
                {greeting.resumeLink && (
                  <a
                    href={greeting.resumeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button"
                    style={{
                      background: "transparent",
                      border: `2px solid ${theme.accentColor}`,
                      color: theme.accentColor,
                      boxShadow: "none",
                    }}
                  >
                    View Resume
                  </a>
                )}
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <FeelingProud theme={theme} />
          </div>
        </div>
      </div>
    </Fade>
  );
}
